import React from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { NotFoundPage } from "./pages/NotFoundPage";
import { DashboardPage } from "./pages/dashbord/IndexPage";
import { ConfirmEmail } from "./pages/portal/ConfirmEmail";
import { LoginPage } from "./pages/portal/LoginPage";
import { ROUTES } from "./resources/constants/routes";
import { ProductPage } from "./pages/dashbord/ProductPage";
import { LocationsPage } from "./pages/locations/LocationsPage";
import { ProfilPage } from "./pages/profil/ProfilPage";
import { RegisterPage } from "./pages/portal/RegisterPage";
import PrivateRoute from "./resources/contexts/PrivateRoute";
import { ResetPassword } from "./pages/portal/ResetPassword";
import { VerifyPhone } from "./pages/portal/VerifyPhone";
import { UserProvider } from "./resources/contexts/UserContext";
import { ToastProvider } from "@postcheesy/ui-lib/molecules";
import { EmailConfirmation } from "./pages/portal/EmailConfirmRedirect";
import { ForgotPassword } from "./pages/portal/ResetRequest";
import { ProfileSetup } from "./pages/profil/ProfileSetup";
import { RouteProvider } from "./resources/contexts/RouteContext";
import { ChangePassword } from "./pages/profil/ChangePassword";


const RootComponent: React.FC = () => {
  return (
    <UserProvider>
      <ToastProvider>
        <Router>
          <RouteProvider>
            <Routes>
              <Route path="*" element={<NotFoundPage />} />

              <Route index element={<Navigate to={ROUTES.LOGIN} />} />

              <Route path={ROUTES.LOGIN} element={<LoginPage />} />
              <Route path={ROUTES.REGISTER} element={<RegisterPage />} />
              <Route path={ROUTES.RESET_REQUEST} element={<ForgotPassword />} />
              <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
              <Route path={ROUTES.CONFIRM_EMAIL} element={<ConfirmEmail />} />
              <Route path={ROUTES.VERIFY_PHONE} element={<VerifyPhone />} />
              <Route path={ROUTES.EMAIL_REDIRECT} element={<EmailConfirmation />} />
              <Route path={ROUTES.PROFILE_SETUP} element={<ProfileSetup />} />

              <Route path={ROUTES.DASHBOARD} element={<PrivateRoute element={<DashboardPage />} />} />
              <Route path={ROUTES.PRODUCT} element={<PrivateRoute element={<ProductPage />} />} />
              <Route path={ROUTES.LOCATIONS} element={<PrivateRoute element={<LocationsPage />} />} />
              <Route path={ROUTES.PROFILE} element={<PrivateRoute element={<ProfilPage />} />} />
              <Route path={ROUTES.CHANGE_PASSWORD} element={<PrivateRoute element={<ChangePassword />} />} />

            </Routes>
          </RouteProvider>
        </Router>
      </ToastProvider>
    </UserProvider >
  );
};

export default RootComponent;
